'use client';

import StoreIcons from './StoreIcons';

export default function Download() {
  return (
    <>
      <section className="section-sm">
        <div className="container space-y-12 text-center container-md">
          {/* Download App Buttons */}
          <h3 className="title">
            Download the <span className="text-primary">PayStop</span> App Now
          </h3>
          <div className="flex items-center justify-center gap-5">
            <StoreIcons />
          </div>
        </div>
      </section>
    </>
  );
}
